// PPS CRM - Analytics Module
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export default function Analytics() {
  const [clients, setClients] = useState(0);
  const [totalCommissions, setTotalCommissions] = useState(0);
  const [loading, setLoading] = useState(true);
  const [timeframe, setTimeframe] = useState('month');
  const [scope, setScope] = useState<'company' | 'agent' | 'client'>('company');
  const [agents, setAgents] = useState<any[]>([]);
  const [clientsList, setClientsList] = useState<any[]>([]);
  const [agentId, setAgentId] = useState('');
  const [clientId, setClientId] = useState('');

  useEffect(() => {
    fetchAnalytics();
    fetchFilters();
  }, []);

  useEffect(() => {
    fetchAnalytics();
  }, [timeframe, scope, agentId, clientId]);

  const fetchAnalytics = async () => {
    try {
      const response = await api.get('/api/analytics', {
        params: {
          timeframe,
          scope,
          agentId: scope === 'agent' ? agentId : undefined,
          clientId: scope === 'client' ? clientId : undefined,
        },
      });
      setClients(response.data.clients || 0);
      setTotalCommissions(Number(response.data.totalCommissions || 0));
    } catch (error) {
      console.error('Error fetching analytics:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFilters = async () => {
    try {
      const [usersRes, clientsRes] = await Promise.all([api.get('/api/users'), api.get('/api/clients')]);
      setAgents((usersRes.data || []).filter((u: any) => u.role === 'AGENT'));
      setClientsList(clientsRes.data || []);
    } catch (error) {
      console.error('Error loading filters:', error);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Analytics</h2>
      <div className="card mb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Timeframe</label>
            <select
              value={timeframe}
              onChange={(e) => setTimeframe(e.target.value)}
              className="w-full px-3 py-2 border border-mid-gray rounded"
            >
              <option value="day">Daily</option>
              <option value="week">Weekly</option>
              <option value="month">Monthly</option>
              <option value="quarter">Quarterly</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Scope</label>
            <select
              value={scope}
              onChange={(e) => setScope(e.target.value as any)}
              className="w-full px-3 py-2 border border-mid-gray rounded"
            >
              <option value="company">Company</option>
              <option value="agent">Agent</option>
              <option value="client">Client</option>
            </select>
          </div>
          {scope === 'agent' && (
            <div>
              <label className="block text-sm font-medium mb-1">Agent</label>
              <select
                value={agentId}
                onChange={(e) => setAgentId(e.target.value)}
                className="w-full px-3 py-2 border border-mid-gray rounded"
              >
                <option value="">Select agent</option>
                {agents.map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.fullLegalName}
                  </option>
                ))}
              </select>
            </div>
          )}
          {scope === 'client' && (
            <div>
              <label className="block text-sm font-medium mb-1">Client</label>
              <select
                value={clientId}
                onChange={(e) => setClientId(e.target.value)}
                className="w-full px-3 py-2 border border-mid-gray rounded"
              >
                <option value="">Select client</option>
                {clientsList.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.fullLegalName}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>
      {loading ? (
        <div className="card p-8 text-center">Loading...</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="card">
            <h3 className="text-sm text-dark-gray mb-2">Active Clients (30 days)</h3>
            <div className="text-3xl font-bold text-primary">{clients}</div>
          </div>
          <div className="card">
            <h3 className="text-sm text-dark-gray mb-2">Available Commissions</h3>
            <div className="text-3xl font-bold text-success">${totalCommissions.toFixed(2)}</div>
          </div>
        </div>
      )}
    </div>
  );
}
